<template>
  <div class="row step-section">
    <div class="col-md-6 col-md-offset-3">
      <div class="confirmation-text">
        <div class="form-group form-inline text-left">
          <span>I, </span>
          <input type="text" v-model="model.client_consulter" class="form-control" :disabled="isReadOnly">
        </div>
        <p class="text-left">agree that I have discussed and understood all the information
        contained within this annual veterinary consultation. </p>

        <p class="text-left">I thereby agree to abide by the correct and safe usage, storage and
        withholding times of all products registered as veterinary medicines by
        the ACVM, as discussed in this consultation.</p>

        <p class="text-left">All medications discussed are for ANIMAL USE ONLY.</p>

        <p class="text-left">Use as directed. Store out of reach of children, in the appropiate
        environment - fridge if required, and out of sunlight.</p>

        <p class="text-left">I will contact VetSouth Ltd straight away should I have an adverse
        reaction to any drug administered that was prescribed by VetSouth
        Ltd.</p>

        <p class="text-left">Date: {{ today }}</p>
        <p class="text-left">Agree <input type="checkbox" v-model="model.signed" :disabled="isReadOnly"></p>
      </div>

      <div v-if="model.signed && !isReadOnly">
        <template v-if="online">
          <button @click="saveAndRedirectHome" type="button" class="btn btn-primary" :disabled="syncing">
            Save and continue
          </button>
        </template>
        <template v-else>
          <button @click="onSubmit" type="button" class="btn btn-success" :disabled="syncing">Save</button>
          <br>
          <p class="alert alert-info">As you are offline you only got the
            possibility to save the consult data but not to sync it to the server.</p>
        </template>

        <img v-if="syncing" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
      </div>

    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import { mapActions } from 'vuex'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        client_consulter: '',
        signed: false,
        signed_at: null,
      },
      syncing: false,
    }
  },
  computed: {
    today: function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return `${dd}/${mm}/${yyyy}`;
    },
    online: function() {
      return navigator.onLine
    },
  },
  methods: {
    ...mapActions('springReview', ['saveConsultData', 'deleteSchema']),
    saveAndRedirectHome: function ()
    {
      this.onSubmit()
      this.$store.dispatch('alert/success', {
        message: 'Data has been saved locally', persist: true
      });
      this.$router.push('/')
    },
    onSaveAndSubmit: function() {
      this.syncing = true

      this.updateCurrentModel(this.model).then(() => {

        let consultParams = {
          clientId: this.$route.params.client_id,
          season: this.$route.params.season,
        }
        this.saveConsultData(consultParams).then(
          success => {
            this.$store.dispatch('alert/success', {message: 'Success! Data has been synced to the server.', persist: true});
            this.syncing = false
            this.deleteSchema()
            this.$router.push('/')
          },
          error => {
            this.syncing = false
          }
        )
      })
      this.$emit('section-changed');
    },
  },
  watch:
  {
    'model.signed': function (value)
    {
      this.model.signed_at = value ? (new Date()).toJSON() : null
    }
  }
};
</script>

<style scoped>
.confirmation-text p {
  font-size: 20px;
}
</style>
